declare const $: any; // jQuery global
import { BookingFormValidator } from "./booking-form-validator";



function validateEventForm(): void {
    let isValid = true;

    $("input[required], select[required]").each(function (this: any) {
        if (!$(this).val()) isValid = false;
    });

    $('input[id*="__Validated"]').each(function (this: any) {
        if ($(this).val()?.toString().toLowerCase() !== "true") isValid = false;
    });

    $("#event-checkout-btn button").prop("disabled", !isValid);
}

function associateValidationClicks(): void {
    // prevent stacking handlers
    $(".input-del-email")
        .off("blur")
        .on("blur", function (this: any) {
            const input = $(this);

            input.addClass("input-loading");
            input.removeClass("border-success border-2");

            const index = input.data("index");
            const email = input.val();

            if (!email) {
                input.removeClass("input-loading");
                validateEventForm();
                return;
            }

            const validationElem = $(`.validated-member-txt[data-index=${index}]`);
            validationElem.hide();

            const encodedEmail = encodeURIComponent(email);

            const eventId = $("#event-delegates").data("eventId") ?? "";

            $.ajax({
                method: "GET",
                url: `/umbraco/surface/eventbookingsurface/validatemembership?email=${encodedEmail}&delIndex=${index}&eventId=${eventId}`,
                async: true
            }).done(function (result: any) {
                input.removeClass("input-loading");

                if (!result || !result.valid) {
                    validationElem.html(`<b>${email}</b> ${result?.reason || "could not be added."}`);
                    validationElem.removeClass("text-success").addClass("text-red").show();

                    input.removeClass("border-success border-2").addClass("input-validation-error");
                    $(`#Delegates_${index}__Validated`).val("false");
                } else {
                    validationElem.html(`<b>${email}</b> can attend this event.`);
                    validationElem.removeClass("text-red").addClass("text-success").show();

                    input.removeClass("input-validation-error").addClass("border-success border-2");
                    $(`#Delegates_${index}__Validated`).val("true");
                }

                validateEventForm();
            });
        });

    $("input[required], select[required], .input-del-email")
        .off("change", validateEventForm)
        .on("change", validateEventForm);
}

// Used in instances of non-payment
function submitEventCheckout(): void {
    const bookingForm = $("#EventBookingForm");

    if (validateEventCheckout(bookingForm)) {
        bookingForm.submit();
        $("#updateButton").prop("disabled", true);
    }
}

// expose globally for inline onclick
(window as any).submitEventCheckout = submitEventCheckout;

function validateEventCheckout(form: any): boolean {
const nativeForm = document.getElementById("EventBookingForm") as HTMLFormElement | null;
const addressValid = nativeForm ? BookingFormValidator.validateCheckoutAddresses(nativeForm) : true;

// Unobtrusive validation
    let formValid = form.valid();

    // Terms agreement. form.valid() above does NOT cover this: jQuery unobtrusive fails to build
    // a `required` rule from data-val-required on a checkbox (verified against jquery-validation
    // 1.19.5 / unobtrusive 3.2.12 — the required adapter fires with the right message, but the
    // rule is not there afterwards; a text input alongside it gets its rule fine). So the box
    // could be left unticked and the booking still went through. BookingFormValidator
    // .setupTermsValidation adds the rule explicitly, which does work — but it is only reached
    // from initCheckoutPage, whose `#paymentMethodTabs` guard matches nothing in this solution,
    // and an unobtrusive re-parse (see the SameAsAbove handler in form-service) would drop the
    // rule again anyway. Checking it here puts the gate on the one path every checkout submit
    // goes through. Scoped to the form rather than the document, per validation.md rule 6.
    const terms = form.find("#TermsAllAgreed");
    if (terms.length) {
        const termsMsg = form.find("[data-valmsg-for=TermsAllAgreed]");

        if (terms.is(":checked")) {
            terms.removeClass("input-validation-error");
            termsMsg.removeClass("field-validation-error").addClass("field-validation-valid").text("");
        } else {
            formValid = false;
            terms.addClass("input-validation-error");
            termsMsg.removeClass("field-validation-valid").addClass("field-validation-error")
                .text("Please agree to the terms and conditions.");
        }
    }

    // Confirm Email must match Email
    const confirmedEmail = $("input[name=ConfirmedEmail]");
    if (!!confirmedEmail.val() && confirmedEmail.val() != $("input[name=Email]").val()) {
        formValid = false;

        confirmedEmail.addClass("input-validation-error");

        const ceValidationMsg = $("span[data-valmsg-for=ConfirmedEmail]");
        ceValidationMsg.removeClass();
        ceValidationMsg.addClass("field-validation-error");
        ceValidationMsg.text("This must match your email to confirm.");
    }

    // Billing Confirm Email must match Billing Email
    const billingConfirmedEmail = $("input[name=BillingConfirmedEmail]");
    if (!!billingConfirmedEmail.val() && billingConfirmedEmail.val() != $("input[name=BillingEmail]").val()) {
        formValid = false;

        billingConfirmedEmail.addClass("input-validation-error");

        const bceValidationMsg = $("span[data-valmsg-for=BillingConfirmedEmail]");
        bceValidationMsg.removeClass();
        bceValidationMsg.addClass("field-validation-error");
        bceValidationMsg.text("This must match your email to confirm.");
    }

    return addressValid && formValid;
}

function prefillFirstDelegateDetails(form: any): void {
    const delegatesContainer = form.find("#event-delegates");

    // Read via .attr(), not .data() — jQuery's .data() auto-coerces a numeric-looking
    // attribute into a JS Number, which then fails Choices.js's strict === value match below.
    const salutation = delegatesContainer.attr("data-user-salutation");
    const firstName = delegatesContainer.data("userFirstName");
    const lastName = delegatesContainer.data("userLastName");
    const email = delegatesContainer.data("userEmail");

    if (!salutation && !firstName && !lastName && !email) {
        return;
    }

    const emailInput = form.find("#Delegates_0__EmailAddress");
    const salutationSelect = form.find("#Delegates_0__Salutation");
    const firstNameInput = form.find("#Delegates_0__FirstName");
    const lastNameInput = form.find("#Delegates_0__LastName");

    if (firstNameInput.length && !firstNameInput.val() && firstName) {
        firstNameInput.val(firstName);
    }

    if (lastNameInput.length && !lastNameInput.val() && lastName) {
        lastNameInput.val(lastName);
    }

    if (salutationSelect.length && !salutationSelect.val() && salutation) {
        // Choices.js wraps this select; if it has already initialised, update it directly too.
        const choices = (salutationSelect[0] as any)?._choices;
        if (choices) {
            choices.setChoiceByValue(salutation);
        }
        salutationSelect.val(salutation);
    }

    if (emailInput.length && !emailInput.val() && email) {
        emailInput.val(email);
        emailInput.trigger("blur");
    }
}

function updateEventDelegates(form: any, quantity: number): void {
    const delegates = form.find("#event-delegates");
    const checkoutBtn = form.find("#event-checkout-btn");
    const delegateInfoHeader = form.find("#event-delegate-info-header");

    if (quantity === 0) {
        checkoutBtn.hide();
        delegateInfoHeader.hide();
        delegates.html("");
        return;
    }

    const rows = delegates.children(".delegate-form");
    const currentCount = rows.length;

    if (currentCount > quantity) {
        for (let i = currentCount - 1; i >= quantity; i--) {
            rows.eq(i).remove();
        }
    } else if (currentCount < quantity) {
        const temp = $("template#event-delegate-template")[0] as HTMLTemplateElement | undefined;
        if (!temp) {
            console.warn("No <template id='event-delegate-template'> found for delegate rows.");
        } else {
            for (let i = currentCount; i < quantity; i++) {
                const html = temp.innerHTML
                    .replace(/\{\{index\}\}/g, i.toString())
                    .replace(/\{\{delegate_title\}\}/g, `Delegate ${i + 1}`);
                delegates.append(html);
            }
        }
    }

    delegateInfoHeader.show();
    checkoutBtn.show();
}

export function initBookingPage(): void {
    $(document).on("change", "select.event-quantity", function (this: any) {
        const $this = $(this);
        const form = $this.parents("form");

        const quantity = parseInt(this.value, 10);
        const packageId = $this.data("package");

        form.find("#SelectedPackage").val(packageId);

        const quantityDropdowns = form.find(".ticket-section__table select.event-quantity");
        if (quantityDropdowns.length > 1) {
            quantityDropdowns.each((_: any, dd: any) => {
                dd.disabled = quantity > 0 && dd !== $this[0];
            });
        }

        updateEventDelegates(form, quantity);
        associateValidationClicks();
        prefillFirstDelegateDetails(form);
        validateEventForm();
    });

    // initial setup
    associateValidationClicks();
    validateEventForm();

    // Restore disabled state for package dropdowns when navigating back with a pre-selected package
    const allQuantityDropdowns = $(".ticket-section__table select.event-quantity");
    if (allQuantityDropdowns.length > 1) {
        let preSelectedDropdown: any = null;
        allQuantityDropdowns.each((_: any, dd: any) => {
            if ((parseInt($(dd).val(), 10) || 0) > 0) {
                preSelectedDropdown = dd;
            }
        });
        if (preSelectedDropdown) {
            allQuantityDropdowns.each((_: any, dd: any) => {
                dd.disabled = dd !== preSelectedDropdown;
            });
        }
    }

    // Restore visual validation state for delegates pre-filled from session
    $(".input-del-email").each(function(this: any) {
        const input = $(this);
        const index = input.data("index");
        const email = input.val();
        if (email && $(`#Delegates_${index}__Validated`).val()?.toString().toLowerCase() === "true") {
            input.addClass("border-success border-2");
            const msg = $(`.validated-member-txt[data-index=${index}]`);
            msg.html(`<b>${email}</b> can attend this event.`);
            msg.removeClass("text-red").addClass("text-success").show();
        }
    });
}